import React from 'react';
import NumberInput from './NumberInput';

// Typed price entry, paired with PriceCalculator beside it — same shape as
// PricePricingPage.js's InlineMoneyEdit: the shared NumberInput holds the
// draft (in the company Number Format) and this commits on blur rather
// than per-keystroke. Holds the unit price in the Customer's Pricing Basis
// (ex GST for Business, inc GST for Retail — see shared/pricingBasis.js).
// Up to 4 decimals, shown in full (2 for a whole-cent price), so a price
// re-keyed from a migrated order (e.g. $5.5682 ex) can match its old Amount
// and what's on screen is always what's saved. onCommit gets the plain
// '1234.56' form.
function LineUnitPriceField({ price, onCommit }) {
  return (
    <NumberInput
      value={price === null || price === undefined ? '' : price}
      minDecimals={2}
      maxDecimals={4}
      min="0"
      placeholder={price === null || price === undefined ? 'Needs price' : undefined}
      onBlur={(e) => {
        // Anything typed past 4 decimals is rounded to 4 here, so the figure
        // the field then shows is exactly the one committed.
        const draft = e.target.value === '' ? '' : String(Math.round(Number(e.target.value) * 10000) / 10000);
        if (draft !== '' && Number(draft) !== Number(price)) onCommit(draft);
      }}
      style={{ flex: 1, minWidth: 60, fontSize: 12, textAlign: 'right' }}
    />
  );
}

export default LineUnitPriceField;
